import React, { Children, useEffect, useMemo, useState } from "react";
import InnerContainer from "../InnerContainer";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { InputGroup } from "@components/_Revamp/InputGroup";
import { capitalize, isEmpty } from "lodash";
import { SCREEN_SIZE } from "@static/screen-size";
import caratIcon from "@assets/icon/carat-right.svg";
import {
  NameSelectorItemProps,
  formatDate,
  getSalutationList,
  nameChunks,
} from "@utils/helpers";
import SwapButton from "./swapButton";
import { useAvivaSelector } from "@redux/hook";
import warningIcon from "@assets/icon/info-yellow.svg";
import ModalNameSelector from "./Modal/ModalNameSelector";

interface IProp {
  onChange: (payload: { itemType: string; index: number; item: any }) => void;
  onSelect: (payload: any) => void;
  onRestart?: () => void;
  index: number;
  itemType: string;
  sideButton: "SELECT" | "RESTART" | null | undefined;
  childData: {
    fullName: string;
    gender: string;
    mobileNum: string;
    nric: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    isDisabled?: boolean;
  };
}

function MyinfoComponent({
  childData,
  index,
  itemType,
  onChange,
  onSelect,
  sideButton,
  onRestart,
}: IProp) {
  const selectedChildNric = useAvivaSelector(
    (state) => state.cancerCoverStep4.selectedChildInfo?.nric || ""
  );
  const [isExpanded, setIsExpanded] = useState(false);
  const [swapName, setSwapName] = useState<string>("");
  const [firstNameListingChucks, setFirstNameListingChucks] = useState<
    NameSelectorItemProps[] | null
  >(null);

  const [lastNameListingChucks, setLastNameListingChucks] = useState<
    NameSelectorItemProps[] | null
  >(null);

  const [names, setNames] = useState(["", ""]);

  const [errors, setError] = useState(() => {
    return {
      email: false,
      phone: false,
    };
  });
  const salutation = useMemo(() => {
    let sal = "-";
    if (childData.gender) {
      sal = childData.gender.toLowerCase() === "male" ? "Mr" : "Ms";
    }
    return sal;
  }, []);

  const onInputChange = (e: any) => {
    // handleChange(e);
    // updateInfoFn && updateInfoFn({ [e.target.name]: e.target.value });
    onChange({
      item: { ...childData, [e.target.name]: e.target.value },
      index,
      itemType,
    });
  };

  const nameChunksProcesses = (myselfData: any, forLocalState: boolean) => {
    let fullName = myselfData["fullName"] || "";
    const tempName = fullName.trim();
    let tempFirstName =
      myselfData["firstName"] ||
      (tempName && tempName.split(" ").slice(0, -1).join(" "));
    let tempLastName =
      myselfData["lastName"] || (tempName && tempName.split(" ").pop());

    nameChunks(
      tempName,
      "firstName",
      tempFirstName,
      setFirstNameListingChucks,
      setLastNameListingChucks
    );
    nameChunks(
      tempName,
      "lastName",
      tempLastName,
      setFirstNameListingChucks,
      setLastNameListingChucks
    );
    if (forLocalState) {
      return;
    }
    let salutationVal = myselfData?.salutation;
    isEmpty(salutationVal) &&
      (salutationVal =
        myselfData?.gender?.toLowerCase() === "male"
          ? "Mr"
          : myselfData?.gender?.toLowerCase() === "female"
          ? "Ms"
          : "");

    // patchValue({
    //   ...myselfData,
    //   firstName: tempFirstName,
    //   lastName: tempLastName,
    //   salutation: salutationVal,
    // });
    onChange &&
      onChange({
        item: {
          ...myselfData,
          firstName: tempFirstName,
          lastName: tempLastName,
          salutation: salutationVal,
        },
        index,
        itemType,
      });
  };
  const firstNameOnChange = (value: any) => {
    let tempName: string = childData["fullName"];
    const fullName = tempName.trim();
    let firstNameItems = value;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = firstNameItems.findIndex(
        (items: any) => i === items.id
      );
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjFirstName.push(tempFNChucks);
      tempObjLastName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    firstNameItems.forEach((e: any, i: number) => {
      fname += e.title + " ";
    });
    tempObjLastName.forEach((e) => {
      e.selected && (lname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    onChange &&
      onChange({
        item: {
          ...childData,
          firstName: fname.trim(),
          lastName: lname.trim(),
        },
        index,
        itemType,
      });
  };

  const lastNameOnchange = (value: any) => {
    let tempName = childData["fullName"];
    const fullName = tempName.trim();
    let lastNameItems = value;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = lastNameItems.findIndex((items: any) => i === items.id);
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjLastName.push(tempFNChucks);
      tempObjFirstName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    lastNameItems.forEach((e: any) => {
      lname += e.title + " ";
    });
    tempObjFirstName.forEach((e) => {
      e.selected && (fname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    onChange &&
      onChange({
        item: {
          ...childData,
          firstName: fname.trim(),
          lastName: lname.trim(),
        },
        index,
        itemType,
      });
  };

  useEffect(() => {
    if (
      childData.fullName.trim().length > 0 &&
      !childData.firstName &&
      !childData.lastName
    ) {
      nameChunksProcesses({ ...childData }, false);
    } else if (
      firstNameListingChucks === null &&
      lastNameListingChucks === null
    ) {
      nameChunksProcesses({ ...childData }, true);
    }
  }, []);

  return (
    <>
      <InnerContainer className={containerstyle}>
        <div
          className={accordTitle}
          onClick={() => {
            setIsExpanded((prev) => !prev);
          }}
        >
          <span>
            <img
              className={isExpanded ? "rotate" : ""}
              src={caratIcon}
              alt="toggle icon"
            />
            <p>{childData.fullName}</p>
          </span>
          {sideButton === "SELECT" && (
            <button
              disabled={childData.isDisabled}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onSelect(childData);
              }}
              className={`select ${
                childData.nric === selectedChildNric && "selected"
              }`}
            >
              {childData.nric === selectedChildNric ? "Selected" : "Select"}
            </button>
          )}
          {sideButton === "RESTART" && (
            <a
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRestart && onRestart();
              }}
              className={`restart`}
            >
              Restart to buy
            </a>
          )}
        </div>
        <MyInfoDataCard isExpanded={isExpanded}>
          <InputGroup
            labelColor="#434343"
            id="fullName"
            name="fullName"
            label="Full Name"
            placeholder=""
            onChange={(e: any) => {
              let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
              // onInputChange({
              //   target: { value: formatted_name, name: e.target.name },
              // });
            }}
            // invalid={!isEmpty("errors?.fullname?.message")}
            // errorMessage={"errors?.fullname?.message"}
            inputProps={{
              textAlign: "left",
              value: childData.fullName || "-",
            }}
            inputType={"input"}
            readOnly={true}
          />
          <InputGroup
            labelColor="#434343"
            id="salutation"
            name="salutation"
            label="Salutation"
            placeholder=""
            onChange={(e: any) => {}}
            invalid={!isEmpty("")}
            errorMessage={""}
            inputProps={{
              textAlign: "left",
              value: salutation,
            }}
            inputType={"input"}
            readOnly={true}
          />
          <InputGroup
            labelColor="#434343"
            id="lastName"
            name="lastName"
            label="Last Name/Family Name"
            swapClassname={swapStyle}
            placeholder=""
            onChange={(e: any) => {
              let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
              onInputChange({
                target: { value: formatted_name, name: e.target.name },
              });
            }}
            invalid={!isEmpty("")}
            errorMessage={""}
            inputProps={{
              textAlign: "left",
              value: childData.lastName || "-",
            }}
            inputType={"swapbuttonname"}
            readOnly={true}
            swapModalOpen={(e) => {
              // setSwapName(e);
              // nameChunksProcesses(values);
            }}
            SwapButton={SwapButton}
            swapButtonOnClick={() => {
              setSwapName("lastName");
            }}
          />
          <InputGroup
            labelColor="#434343"
            id="firstName"
            name="firstName"
            label="First Name/Given Name"
            swapClassname={swapStyle}
            onChange={(e: any) => {
              let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
              onInputChange({
                target: { value: formatted_name, name: e.target.name },
              });
            }}
            invalid={!isEmpty("")}
            errorMessage={"errors?.firstName?.message"}
            inputProps={{
              textAlign: "left",
              value: childData.firstName || "-",
            }}
            inputType={"swapbuttonname"}
            readOnly={true}
            // swap={ childData.fullName ? "firstName" : undefined}
            swapModalOpen={(e) => {
              // nameChunksProcesses(values);
            }}
            SwapButton={SwapButton}
            swapButtonOnClick={() => {
              setSwapName("firstName");
            }}
          />

          <div className="nameDisclaimer">
            <span>
              <img src={warningIcon} alt="warning icon" />
              <p>
                Please <b>ensure your name sequence is correct</b> before
                proceeding to avoid payment issues and maintain accuracy of your
                records.
              </p>
            </span>
          </div>

          <InputGroup
            labelColor="#434343"
            id="dateOfBirth"
            name="dateOfBirth"
            label="Date of Birth"
            placeholder=""
            onChange={onInputChange}
            // invalid={!isEmpty("errors?.dateOfBirth?.message")}
            // errorMessage={"errors?.dateOfBirth?.message"}
            inputProps={{
              textAlign: "left",
              value: formatDate(childData.dateOfBirth) || "",
            }}
            onBlurShowError={true}
            inputType={"input"}
            readOnly={true}
          />
          <InputGroup
            labelColor="#434343"
            id="nric"
            name="nric"
            label="NRIC"
            placeholder=""
            onChange={onInputChange}
            // invalid={!isEmpty("errors?.nric?.message")}
            // errorMessage={"errors?.nric?.message"}
            inputProps={{
              textAlign: "left",
              value: childData.nric || "",
            }}
            onBlurShowError={true}
            inputType={"input"}
            readOnly={true}
          />
          <InputGroup
            labelColor="#434343"
            id="gender"
            name="gender"
            label="Gender"
            placeholder=""
            onChange={onInputChange}
            // invalid={!isEmpty("")}
            // errorMessage={""}
            inputProps={{
              textAlign: "left",
              value: capitalize(childData.gender) || "",
            }}
            onBlurShowError={true}
            inputType={"input"}
            readOnly={true}
          />
        </MyInfoDataCard>
      </InnerContainer>
      <ModalNameSelector
        show={swapName !== "" ? true : false}
        headerTitle={
          swapName === "firstName"
            ? "first name/given name"
            : "last name/family name"
        }
        selectorItems={
          swapName === "firstName"
            ? firstNameListingChucks || []
            : lastNameListingChucks || []
        }
        onCancelClick={() => {
          setSwapName("");
        }}
        onSaveClick={(value) => {
          swapName === "firstName" && firstNameOnChange(value.nameItems);
          swapName === "lastName" && lastNameOnchange(value.nameItems);
          setSwapName("");
        }}
      />
    </>
  );
}

export default MyinfoComponent;

const accordTitle = css`
  cursor: pointer;
  display: flex;
  .restart {
    text-decoration: underline;
    color: #883e89;
    font-size: 14px;
    font-weight: 600;
  }

  .select {
    background-color: transparent;
    padding: 12px 40px;
    min-width: 144px;
    border-radius: 100px;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.18px;
    color: #883e89;
    border: 1px solid #883e89;
    cursor: pointer;
    max-height: 33px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .selected {
    background-color: #883e89;
    color: white;
  }
  button:disabled {
    cursor: no-drop;
    background-color: #d4bfd7;
    color: white;
    border: none;
  }
  span {
    display: flex;
    flex: 1;
    justify-items: center;
    align-items: center;
    gap: 16px;

    p {
      font-size: 18px;
      font-weight: 600;
      line-height: 25.2px;
    }

    img {
      margin-top: -6px;
    }
  }

  .rotate {
    transform: rotate(90deg);
  }
`;

const MyInfoDataCard = styled.div<{ isExpanded: boolean }>`
  display: grid;
  row-gap: 36px;
  column-gap: 24px;
  height: ${(prop) => (prop.isExpanded ? "860px" : "0px")};
  transition: all 0.3s linear;
  overflow: hidden;
  & > div {
    cursor: default;
  }
  .nameDisclaimer {
    /* grid-column-start: 1;
      grid-column-end: 3; */
    border-radius: 16px;
    padding: 16px;
    background-color: #fffce4;
    color: #434343;
    span {
      display: flex;
      gap: 8px;
      align-items: flex-start;
      p {
        font-size: 14px;
        line-height: 19.6px;
        b {
          font-weight: 600;
        }
      }
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    grid-template-columns: repeat(2, 1fr);
    padding: ${(prop) => (prop.isExpanded ? "24px 40px" : "0px 40px")};
    height: ${(prop) => (prop.isExpanded ? "531px" : "0px")};

    .nameDisclaimer {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }
`;

const swapStyle = css`
  display: flex;
  align-items: flex-end;
  /* Input wrapper: take remaining space and allow shrinking so long child
     names truncate inside the input instead of being covered by the swap
     button. min-width: 0 is required for a flex item to shrink below its
     content width. */
  & > div:first-child {
    flex: 1 1 auto;
    min-width: 0;
    width: unset;
  }
  & > div:first-child input {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  button {
    flex: 0 0 auto;
    margin-top: -10px;
  }
`;

const containerstyle = css`
  margin-bottom: 24px;
`;
